/* ZEPHIR - Decide si el footer cabe en la ventana. Pareja de
 * assets/zephir-footer-ajuste.css, que es donde estan las reglas.
 *
 * QUE HACE Y POR QUE. El footer se revela como una cortina: queda fijo al fondo
 * de la ventana y el contenido de la pagina se levanta destapandolo. Eso solo
 * funciona si el footer CABE en la ventana. Medido: ventana de 609px de alto,
 * footer de 729px -> los 120px de arriba del footer quedaban fuera de la
 * pantalla, sin forma de llegar a ellos, y la newsletter no se veia. Le pasa a
 * cualquier portatil de pantalla corta o a cualquiera con la ventana a media
 * altura; no es un caso raro.
 *
 * Aqui solo se pone o se quita la clase zph-foot-cabe en <html>. Todo lo que
 * pasa con esa clase esta en el CSS. Si no cabe, el footer vuelve al flujo
 * normal: se ve entero, sin el efecto. Un footer sin animacion se puede usar;
 * uno recortado, no.
 *
 * EL ALTO EN SI (--zph-foot-h) NO SE TOCA AQUI: lo publica el script de
 * sections/zephir-footer.liquid, que es de donde sale el margin-bottom del
 * contenido. Este archivo solo decide el si o el no.
 *
 * POR QUE ESTA APARTE DE LA SECCION: la seccion pesa 26 KB y reescribirla
 * entera por API para anadir tres lineas no compensa. La capa de ajustes
 * (este archivo y su CSS) se toca sola.
 *
 * EL MARGEN DE 24px no es decorativo: si se exige solo h <= innerHeight, un
 * footer que mide exactamente lo que la ventana queda pegado arriba y abajo sin
 * un pixel de respiro, y basta que aparezca una barra del navegador para que se
 * recorte. Se pide que sobre algo.
 */
(function () {
  'use strict';

  var raiz = document.documentElement;
  var MARGEN = 24;

  function decidir() {
    var pie = document.getElementById('zph-foot');
    if (!pie) return;
    /* offsetHeight y no getBoundingClientRect: da el alto de la caja sin que
       influyan transforms, y aqui lo que importa es el hueco que ocupa. */
    var cabe = pie.offsetHeight <= (window.innerHeight - MARGEN);
    // Solo se escribe si cambia: tocar classList en cada resize provoca
    // recalculos de estilo innecesarios mientras se arrastra la ventana.
    if (cabe === raiz.classList.contains('zph-foot-cabe')) return;
    raiz.classList.toggle('zph-foot-cabe', cabe);
  }

  decidir();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decidir);
  }
  window.addEventListener('load', decidir);
  window.addEventListener('resize', decidir);

  /* El footer cambia de alto cuando cambian sus columnas o el ancho de la
     ventana; sin esto, la decision se quedaria tomada con el alto de antes. */
  if (window.ResizeObserver) {
    var esperar = setInterval(function () {
      var pie = document.getElementById('zph-foot');
      if (!pie) return;
      clearInterval(esperar);
      new ResizeObserver(decidir).observe(pie);
      decidir();
    }, 250);
    // Red de seguridad: si el footer no aparece nunca, no dejar el intervalo vivo.
    setTimeout(function () { clearInterval(esperar); }, 10000);
  }
})();
